import React from 'react';
import ReactDOM from 'react-dom';
import LandlordDocsCheckout from './components/LandlordDocsCheckout';
import dataFetcher from '../../apps/commerce/helpers/data_fetcher';
import { fetchData } from '../../helpers/base_data_fetcher';

if (typeof module !== 'undefined') {
  if (module && module.hot) {
    module.hot.accept();
  }
}

// Select mount elements
const mountElements = document.querySelectorAll('.landlord-docs-checkout');

// Loop on each instance
mountElements.forEach((mountElement) => {
  // Initialize app function
  function initialiseApp({
    amount,
    baseUrl,
    buttonText,
    context,
    currency,
    currencySymbol,
    csEmail,
    modalTitle,
    loginLink,
    phoneNumber,
    platform,
    productId,
    productName,
    quantity,
    siteId,
    staticFileServer,
    subDirectory,
    trackingCategory,
    trackingDesc,
    userId,
    email,
    localisations,
  }) {
    ReactDOM.render(
      <LandlordDocsCheckout
        amount={amount}
        email={email}
        baseUrl={baseUrl}
        buttonText={buttonText}
        context={context}
        csEmail={csEmail}
        currency={currency}
        currencySymbol={currencySymbol}
        loginLink={loginLink}
        modalTitle={modalTitle}
        phoneNumber={phoneNumber}
        platform={platform}
        productId={productId}
        productName={productName}
        quantity={quantity}
        siteId={siteId}
        staticFileServer={staticFileServer}
        subDirectory={subDirectory}
        trackingCategory={trackingCategory}
        trackingDesc={trackingDesc}
        userId={userId}
        localisations={localisations.upgrade}
      />,
      mountElement,
    );
  }

  // Update when mounted
  if (mountElement) {
    Promise.all([
      fetchData('site'),
      fetchData('customer'),
      dataFetcher.getContext(),
      fetchData('commerce.miscellaneous.context'),
      dataFetcher.getLocalisations(),
    ]).then(([site, customer, contextData, context, localisations]) => {
      // Get dataset params
      const {
        amount,
        buttonText,
        email,
        modalTitle,
        loginLink,
        productId,
        productName,
        trackingCategory,
        trackingDesc,
        quantity,
      } = mountElement.dataset;

      const {
        currency_symbol: currencySymbol,
        static_files_server: staticFileServer,
        base_url: baseUrl,
        sub_dir: subDirectory,
        id: siteId,
        phone_number: phoneNumber,
        cs_email: csEmail,
        currency,
      } = site;

      const { id: userId } = customer;
      const { platform } = contextData;

      // Initialize
      initialiseApp({
        amount,
        baseUrl,
        buttonText,
        context,
        csEmail,
        currency,
        currencySymbol,
        email,
        loginLink,
        modalTitle,
        phoneNumber,
        platform,
        productId,
        productName,
        quantity,
        siteId,
        staticFileServer,
        subDirectory,
        trackingCategory,
        trackingDesc,
        userId,
        localisations,
      });
    });
  }
});
